<template>
  <div class="sgs-index-box" @scroll="scrollView">
    <div class="bg-box">
      <img class="bg-img" src="https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/bg.jpg" />
      <img class="bg-gif" src="https://c-newyear-cdn.gongjiayun.cn/nonghang/烟花.gif" />
    </div>
    <div class="insert-img-box">
      <div v-for="(item, index) in list" :key="index">
        <div
          v-show="scrollNum >= item.top"
          :class="item.className + '-box ' + item.animate "
          class="animate__animated img-box"
        >
          <img @click="goToPage(item)" :class="item.className" :src="item.imgUrl" />
          <img
            @click="goToPage(item)"
            :class="item.className + '-point'"
            v-if="item.title !== '领导新春'"
            class="point-gif"
            src="https://c-newyear-cdn.gongjiayun.cn/nonghang/点击.gif"
            mode="widthFix"
          />
          <div class="video-box" v-if="item.title === '领导新春'" @click.stop="goToPage(item)">
            <video
              controls
              class="video-content"
              ref="videoObj"
              src="https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/a.mp4"
              :style="{'background-image':'url(https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/a.mp4?vframe/jpg/offset/0/w/600)'}"
            ></video>
          </div>
        </div>
      </div>
    </div>
    <audio
      v-show="false"
      ref="audioObj"
      id="audio"
      autoplay
      loop
      src="https://c-newyear-cdn.gongjiayun.cn/nonghang/a.mp3"
    ></audio>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false,
      list: [
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/01.png",
          className: "img-01",
          animate: "animate__zoomIn",
          url: "",
          title: "领导新春",
          top: 0
        },
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/02.png",
          className: "img-02",
          animate: "animate__fadeInDown",
          url: "/pages/lottery/lottery?id=470",
          title: "扭转乾坤",
          top: 300
        },
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/03.png",
          className: "img-03",
          animate: "animate__fadeInUp",
          url: "/pages/contest/vote?id=1065",
          title: "云上运动",
          top: 600
        },
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/04.png",
          className: "img-04",
          animate: "animate__zoomIn",
          url: "/pages/contest/vote?id=1066",
          title: "书香筑梦",
          top: 1050
        },
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/06.png",
          className: "img-05",
          animate: "animate__fadeInUp",
          url: "/pages/contest/vote?id=1067",
          title: "秀出自己才艺",
          top: 1400
        },
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/05.png",
          className: "img-06",
          animate: "animate__fadeInDown",
          url: "/pages/contest/vote?id=1068",
          title: "晒晒我的年味儿",
          top: 1700
        },
        // {
        //   imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/07.png",
        //   className: "img-07",
        //   animate: "animate__tada",
        //   url: "/pages/contest/vote?id=650",
        //   title: "我家年味",
        //   top: 2000
        // },
        // {
        //   imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/08.png",
        //   className: "img-08",
        //   animate: "animate__fadeInRight",
        //   url: "/pages/custom_page/custom_page?id=997",
        //   title: "趣味春节",
        //   top: 2300
        // },
        {
          imgUrl: "https://c-newyear-cdn.gongjiayun.cn/jiaoyugonghui2/07.png",
          className: "img-07",
          animate: "animate__zoomIn",
          url: "/pages/exam/detail?id=1351",
          title: "牛气冲天",
          top: 2000
        }
      ],
      scrollNum: 0,
      lotteryNum: 0,
      audioContext: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      console.log(this.$refs.videoObj);
      console.log(this.$refs.audioObj);
      this.audioObj = this.$refs.audioObj;
      this.videoObj = this.$refs.videoObj[0];
      this.audioObj.loop = true;
      this.audioObj.autoplay = true;
      // this.audioObj.play();

      window.onscroll = () => {
        this.scrollView();
      };
      this.autoPlayAudio1();
      // window.ontouchstart = () => {
      //   this.audioObj.play();
      // };
    },
    autoPlayAudio1() {
      wx.config({
        // 配置信息, 即使不正确也能使用 wx.ready
        debug: false,
        appId: "",
        timestamp: 1,
        nonceStr: "",
        signature: "",
        jsApiList: []
      });
      wx.ready(function() {
        document.getElementById("audio").play();
      });
    },

    destory() {
      window.ontouchstart = null;
      this.audioObj.pause();
      // this.videoObj.pause();
    },
    scrollView() {
      // console.log(window.pageYOffset);
      if (this.scrollNum < window.pageYOffset) {
        this.scrollNum = window.pageYOffset;
      }
    },
    goToPage(item) {
      // console.log(item.url);
      // this.destory();
      if (item.url) {
        uni.navigateTo({
          url: item.url
        });
      }
      if (item.title === "领导新春") {
        this.playVideo();
      }
    },
    playVideo() {
      this.destory();
      this.showVideo = true;
      if (this.videoObj.paused) {
        this.videoObj.play();
      } else {
        this.videoObj.pause();
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css");

// @import './anime/anime.scss';
.sgs-index-box {
  // background: url("@/assets/image/sgs_index/bg.png");
  // background-size: contain;
  // min-height: 100vh;
  // position: fixed;
  // top: 0;
  // bottom: 0;
  // height: 8720px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  .video-box {
    position: absolute;
    left: 0;
    right: 12%;
    bottom: 43%;
    top: 1.4rem;
    margin-left: 13.5%;
    z-index: 1;
    .video-content {
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
    }
    .icon-box {
      position: absolute;
      top: -2px;
      left: 13.5%;
      right: 12.5%;
      // width: 100%;
      height: 3.45rem;
      background: rgba(0, 0, 0, 0.6);
      .play-icon {
        position: absolute;
        left: 41%;
        top: 32%;
        width: 50px;
        height: 50px;
        z-index: 2;
      }
    }
  }
  .bg-box {
    position: relative;
    height: 100%;
    width: 100%;
    // overflow: auto;
    .bg-img {
      width: 100%;
      height: auto;
      max-width: 100%;
      //   max-height: 100%;
    }
    .bg-gif {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }
  .insert-img-box {
    position: absolute;
    top: 8.7rem;
    left: 0;
    height: 100%;
    width: 100%;
    image {
      width: 100%;
      height: auto !important;
    }
    .img-box {
      position: relative;
      .propmt-num-box {
        position: absolute;
        top: 664px;
        left: 480px;
        width: 70px;
        height: 70px;
        background-color: rgb(223, 84, 79);
        border-radius: 50%;
        text-align: center;
        line-height: 70px;
        font-size: 50px;
        font-weight: bold;
        border: 1px black solid;
      }
    }
    .point-gif {
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      opacity: 0.8;
    }
    .img-01 {
      width: 84%;
      margin-bottom: 30%;
      margin-left: 8%;
      position: relative;
      z-index: 10;
      //   animation-name: backInLeft;
    }
    .img-01-point {
      margin-top: 35%;
      margin-left: 45%;
    }
    .img-02 {
      width: 92%;
      margin-bottom: 2.3%;
      margin-left: 8%;
      //   animation-name: backInRight;
    }
    .img-02-point {
      margin-top: 36%;
      margin-left: 67%;
    }
    .img-03 {
      width: 81%;
      margin-bottom: -5%;
      //   animation-name: bounceInLeft;
    }
    .img-03-point {
      margin-top: 30%;
      margin-left: 30%;
    }
    .img-04 {
      width: 77%;
      margin-bottom: -2%;
      margin-left: 23%;
      //   animation-name: bounceInRight;
    }
    .img-04-point {
      margin-top: 40%;
      margin-left: 60%;
    }
    .img-05 {
      width: 77%;
      margin-bottom: -8%;
      //   animation-name: fadeInLeft;
    }
    .img-05-point {
      margin-top: 30%;
      margin-left: 30%;
    }
    .img-06 {
      width: 92%;
      margin-bottom: 26%;
      margin-left: 8%;
      //   animation-name: fadeInRight;
    }
    .img-06-point {
      margin-top: 50%;
      margin-left: 60%;
    }
    .img-07 {
      width: 100%;
      // margin-bottom: 14%;
      //   animation-name: lightSpeedInLeft;
      //   animation-timing-function: ease-out;
    }
    .img-07-point {
      margin-top: 50%;
      margin-left: 45%;
    }
    .img-08 {
      width: 89%;
      margin-bottom: 13%;
      margin-left: 11%;
      //   animation-name: lightSpeedInRight;
      //   animation-timing-function: ease-out;
    }
    .img-08-point {
      margin-top: 40%;
      margin-left: 50%;
    }
    .img-09 {
      width: 100%;
      //   margin-bottom: 100px;
      //   animation-name: rotateInUpLeft;
      //   transform-origin: left bottom;
    }
    .img-09-point {
      margin-top: 50%;
      margin-left: 45%;
    }
  }
}
</style>